<script>
  import { experience } from "@stores/global";
  import { supportsEnhancedExperience, supportsNativeHls } from "@utils/support";
  import ConversationVideo from "@components/ConversationVideo";
  import DwellVideo from "@components/DwellVideo";

  export let conversation;
  export let dwell;

  const isPlaylist = conversation && conversation.includes(".m3u8");

  let showVideos = true;

  if (!supportsEnhancedExperience && isPlaylist && !supportsNativeHls) {
    showVideos = false;
  }
</script>

<style>
  .videos {
    background-color: var(--background-color);
    overflow: hidden;
    position: relative;
  }

  .videos[data-aspect-ratio="1:1"] {
    padding-bottom: 100%;
  }

  .videos[data-aspect-ratio="4:3"] {
    padding-bottom: 75%;
  }

  .videos[data-aspect-ratio="16:9"] {
    padding-bottom: 56.25%;
  }

  :global(.enhanced) .videos-container,
  :global(.enhanced) .videos {
    height: 100%;
    left: 0;
    padding: 0 !important;
    position: absolute;
    top: 0;
    width: 100%;
  }

  :global(html:not(.enhanced)) .videos-container {
    position: relative;
  }
</style>

<div class="videos-container">
  {#if showVideos}
    <div class="videos" data-aspect-ratio={$experience.aspectRatio || "16:9"}>
      {#if supportsEnhancedExperience}
        <DwellVideo src={dwell} />
      {/if}

      <ConversationVideo src={conversation} />
    </div>
  {/if}

  <slot />
</div>
